import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/photos/info.svg'
import _imports_1 from '@/assets/photos/download.svg'
import _imports_2 from '@/assets/photos/trashBin.svg'
import _imports_3 from '@/assets/video/video-play.svg'
import _imports_4 from '@/assets/photos/download1.svg'
import _imports_5 from '@/assets/chat/empty-img-default.svg'
import _imports_6 from '@/assets/photos/arrow.svg'
import _imports_7 from '@/assets/general/cancleWhiteBtn.svg'


const _withScopeId = n => (_pushScopeId("data-v-7ed8e8e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video" }
const _hoisted_2 = {
  key: 0,
  class: "headerInfo"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "videoBox" }
const _hoisted_5 = { class: "videosTop" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = {
  class: "buttomItem pointer",
  style: {"margin-right":"16px"}
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div style=\"padding:0px 14px;\" class=\"custom-loading\" data-v-7ed8e8e6><svg class=\"circular\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-7ed8e8e6><g clip-path=\"url(#clip0_8710_13397)\" data-v-7ed8e8e6><path opacity=\"0.2\" d=\"M8 1.3335V4.00016\" stroke=\"#303133\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7ed8e8e6></path><path opacity=\"0.6\" d=\"M8 12V14.6667\" stroke=\"#303133\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7ed8e8e6></path><path opacity=\"0.9\" d=\"M3.28662 3.28662L5.17329 5.17329\" stroke=\"#303133\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7ed8e8e6></path><path opacity=\"0.5\" d=\"M10.8267 10.8267L12.7133 12.7133\" stroke=\"#303133\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7ed8e8e6></path><path opacity=\"0.8\" d=\"M1.3335 8H4.00016\" stroke=\"#303133\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7ed8e8e6></path><path opacity=\"0.4\" d=\"M12 8H14.6667\" stroke=\"#303133\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7ed8e8e6></path><path opacity=\"0.7\" d=\"M3.28662 12.7133L5.17329 10.8267\" stroke=\"#303133\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7ed8e8e6></path><path opacity=\"0.3\" d=\"M10.8267 5.17329L12.7133 3.28662\" stroke=\"#303133\" stroke-width=\"1.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-7ed8e8e6></path></g><defs data-v-7ed8e8e6><clipPath id=\"clip0_8710_13397\" data-v-7ed8e8e6><rect width=\"16\" height=\"16\" fill=\"white\" data-v-7ed8e8e6></rect></clipPath></defs></svg></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "videoMiddle" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  id: "contentsBox",
  class: "contentsBox"
}
const _hoisted_14 = { class: "sectionBox" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "videoCheckBox checkboxDiv" }
const _hoisted_17 = { class: "videoContents" }
const _hoisted_18 = ["id"]
const _hoisted_19 = ["src", "onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "checkboxDiv" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 2,
  class: "empty"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "empty-text" }
const _hoisted_26 = { class: "pagination" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_28 = { class: "paginationBox" }
const _hoisted_29 = {
  key: 1,
  class: "videoPreview"
}
const _hoisted_30 = ["src", "controls"]
const _hoisted_31 = { class: "videotrans absoluteCenter" }

import { ref, computed, onMounted, Ref, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { deletePhoto } from "@/api/devices";
import { getVideoApi } from "@/api/video";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import { getFileLinkApi } from '@/api/chat/index';
import { dateFormat, dateFormatAm } from "@/utils/format";
import { downloadVideo } from "@/utils/downloadFile";
import JSZip from 'jszip';
import loading from "@/components/chat/loading.vue";
import { ElMessage } from "element-plus";
import moment from "moment";
import changeCancel from "@/components/homePage/tabItem/changeCancel.vue";
import { gaEvent } from "@/utils/format";
import { videoTranscodeHandler, exitFfmpeg } from '@/utils/common'
import emitter from '@/utils/eventBus';
import { jsonData } from '@/mock/video.js'


interface videoItem {
    // 根据实际情况定义 videoItem 的属性
    date: string;
    // ... 其他属性
}

export default /*#__PURE__*/_defineComponent({
  __name: 'video',
  emits: ['updateHeaderDate'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const Emits = __emit
const isVibe = computed(() => !store.state.isVibe);
const store = useStore();
const selectedTagName = ref(1)//当前选中的tags 1照片2文件夹
const selectedArray = ref([])//所有选中的相片
const showUpdateTime = ref(false) //是否展示更新时间
let lastUpdateTime = ref(0)// 最后更新时间
const showRightBox = ref(true) //是否展示时间筛选
let startTime = ref('')// 开始时间
let endTime = ref('')//结束时间
const currentPage = ref(1) // 当前的页数
const albumList = ref([]) //文件夹的数组
const albumCurrName = ref('')//当前文件夹的名称
const albumVideo = ref(false) //文件夹中的图片
const isShowDia = ref(false)//是否展示弹窗
const previewImgList = ref([])//预览的照片数组
const currentPreviewIndex = ref(0);//预览第几张图片
const videoLoading = ref(false);//图片loading
const totalNum = ref(0) //总数量
const albumName = ref('')//文件夹名称
const isFirst = ref(false) //是否第一次进来
const downloadLoading = ref(false) //下载的loading
const currentVideo = ref()//当前点击的video对象
const isShowVideoPreview = ref(false) //是否展示video
const appId = computed(() => store.state.currentDeviceInfo.apple_id); //apple_id
const isExpired = computed(() => store.state.currentDeviceInfo.is_expired); //apple_id
const showTrans = ref(false) //是否展示出转码中
const showTransFail = ref(false) // 是否展示出转码失败
const currentProgress = ref(0)//转码的进度
const iscanPlay = ref() //视频是否能正常播放
const videoListArray: Ref<videoItem[][]> = ref([]);//图片数组
const isAllSelect = computed(() => {//是否全选
    // console.log("computed:", selectedArray.value.length, previewImgList.value);

    return (selectedArray.value.length == previewImgList.value.length) && selectedArray.value.length > 0
})
const deviceId = computed(() => {//设备id
    return store.state.currentDeviceInfo.id;
});
const deviceType = computed(() => {//设备id
    return store.state.deviceType;
});
const messageToastType = computed(() => store.state.messageToastType);
//获取信息
const getVideoList = async (name?: string, isSync?: boolean) => {
    const chatListSourceRef = computed(() => store.state.photoInfoSource);
    console.log("chatListSourceRef:", chatListSourceRef.value);
    // 取消掉上一次请求
    chatListSourceRef.value &&
        chatListSourceRef.value.cancel("请勿频繁请求会话列表接口");
    console.log('showRightBox.value', showRightBox.value);
    console.log('name', name);


    // videoListArray.value = []
    // let typeC;//1:照片 2:文件夹
    // if (selectedTagName.value == 1 || (selectedTagName.value == 2 && albumVideo.value)) {
    //     typeC = 1
    // } else if (selectedTagName.value == 2 && !albumVideo.value) {
    //     typeC = 2
    // }
    let params = {} as {
        device_id?: any;
        page: number;
        // type?: any;
        start_date?: any;
        end_date?: any;
        album_name?: any;
        apple_id?: any; // 添加了可选的 apple_id 属性
    }
    if (!isVibe.value) {
        setTimeout(() => {
            videoLoading.value = true
        }, 1)
        console.log("././././././././");
        if (selectedTagName.value == 2 && albumVideo) name = albumName.value
        console.log("selectedTagName.value == 2 && albumVideo:", selectedTagName.value == 2 && albumVideo.value);
        console.log("name:", name);
        params = {
            device_id: deviceId.value,
            // type: typeC,
            start_date: showRightBox.value ? startTime.value : 1609430400,
            end_date: showRightBox.value ? endTime.value : moment().add(12, "M").format("X"),
            page: currentPage.value,
            album_name: name ? name : ''
        }
    } else {
        lastUpdateTime.value = jsonData.update_time
        showUpdateTime.value = true
        videoListArray.value = jsonData.data
        gaEvent("Video_Show", {
            event_category: "Video",
            event_label: '1ms',
        });
        videoLoading.value = false
        if (isFirst.value) return
        gaEvent("Video_PV", {
            event_category: "Video",
            event_label: 'Data',
        });
        isFirst.value = true
        return
    }

    let videoApi: any = getVideoApi
    // if (deviceType.value) {
    //     console.log("deviceType.valuedeviceType.value:", deviceType.value);

    //     if (selectedTagName.value == 1 && !isExpired.value && !isVibe.value) {
    //         videoApi = iosPhotosApi
    //         params = {
    //             page: currentPage.value,
    //         }
    //     } else {
    //         params.apple_id = appId.value
    //         params.album_name = params.album_name ? params.album_name : (isVibe.value ? '' : 'system-album-1')
    //         delete params.device_id; // 删除 device_id 属性
    //     }

    // }
    // console.log("到底调的啥:", deviceType.value && selectedTagName.value == 1, typeC);
    //只有ios查看全部照片的时候才调这个接口
    // if (deviceType.value && selectedTagName.value == 1 && !isVibe.value && !isExpired.value) videoApi = iosPhotosApi
    // if (typeC == 2) {
    //     if (params.start_date) {
    //         delete params.start_date
    //         delete params.end_date
    //     }
    // }
    let gaStartime = new Date().getTime()
    console.log("videoListArray:", videoListArray.value);

    videoApi(params, appId.value)
        .then(async (res: any) => {
            console.log("res:::", res);
            let updateTime = ((new Date().getTime() - gaStartime))
            gaEvent("Video_interface", {
                event_category: "Video",
                event_label: updateTime + 'ms',
            });
            console.log("updateTime:", updateTime);

            videoListArray.value = []
            selectedArray.value = []
            previewImgList.value = []
            // albumList.value = []
            let data = res.data?.data
            if (!data.videos) {
                console.log("videos没数据了喂");

                videoLoading.value = false
                return
            }
            let onePageList = data.videos;
            // console.log("deviceType.value && selectedTagName.value == 2 && !albumVideo && onePageList[0].type == 1:", deviceType.value, selectedTagName.value == 2, !albumVideo.value, onePageList[0].type == 1);

            // if (deviceType.value && selectedTagName.value == 2 && !albumVideo.value && onePageList[0].type == 1) return
            if (!isSync) {
                lastUpdateTime.value = data.update_time
                if (lastUpdateTime.value) {
                    showUpdateTime.value = true
                } else {
                    showUpdateTime.value = false
                }
            }
            totalNum.value = data.total
            if (isSync) {
                if (lastUpdateTime.value == data.update_time) {
                    ElMessage({
                        message: t("famikeep200['Synchronization successful, no new data']"),
                        type: "success",
                    });
                } else {
                    ElMessage({
                        message: t("chat.syncSuccessed"),
                        type: "success",
                    });
                }
                lastUpdateTime.value = data.update_time
                if (lastUpdateTime.value) {
                    showUpdateTime.value = true
                } else {
                    showUpdateTime.value = false
                }
                // } else {
                //   showUpdateTime.value = false
                // }
                gaEvent("Video_Sync", {
                    event_category: "Video",
                    event_label: 'Success',
                });
            }
            if (onePageList && onePageList.length > 0 && (selectedTagName.value == 1 || albumVideo.value)) {
                const onePageListPromise = onePageList.map(
                    async (item: any, index: any) => {
                        // const fileURL = await getFileLinkByKey(item.oss_key);
                        const dateYMD = isVibe.value ? dateFormatAm(item.date, "YYYY-MM-DD") : dateFormat(item.date, "YYYY-MM-DD");
                        return {
                            ...item,
                            // file_url: fileURL,
                            dateYMD: dateYMD,
                            isSelect: false
                        };
                    }
                );
                onePageList = await Promise.all(onePageListPromise);
                console.log("onePageList:", onePageList);
                const videoList = new Map();
                onePageList.forEach((item: any) => {
                    const date = item.dateYMD;
                    if (!videoList.has(date)) {
                        videoList.set(date, []);
                    }
                    videoList.get(date).push(item);
                });
                videoListArray.value = Array.from(videoList.entries())
                    .map(([date, items]) => {
                        console.log("items:", items);
                        if (items && items.length > 0) {
                            items.forEach((item: any) => {
                                // console.log("item:", item);
                                previewImgList.value.push(item.thumb_url ? item.thumb_url : item.origin_url)
                            })
                        }
                        const year = dateFormat(date, "YYYY-MM-DD");
                        const isAllDaySelect = false
                        return [year, isAllDaySelect, items];
                    })
                console.log("videoList:", videoList);
                console.log("videoListArray:", videoListArray);
            }
            // else if (onePageList && onePageList.length > 0 && selectedTagName.value == 2) {
            //     albumList.value = onePageList
            //     if (deviceType.value) {
            //         albumList.value.forEach((item: any) => {
            //             if (item.name == "system-album-1") {
            //                 item.iosname = t("famikeep210.Gallery")
            //             } else if (item.name == "system-album-2") {
            //                 item.iosname = t("famikeep210.Recent Projects")
            //             } else if (item.name == "system-album-3") {
            //                 item.iosname = t("famikeep210.Personal Collection")
            //             } else if (item.name == "system-album-4") {
            //                 item.iosname = t("famikeep210.Recently Deleted")
            //             } else if (item.name == "system-album-5") {
            //                 item.iosname = t("famikeep210.Video")
            //             } else if (item.name == "system-album-6") {
            //                 item.iosname = t("famikeep210.Live Photos")
            //             } else if (item.name == "system-album-7") {
            //                 item.iosname = t("famikeep210.Exposure Photos")
            //             } else if (item.name == "system-album-8") {
            //                 item.iosname = t("famikeep210.Panoramic Photos")
            //             } else if (item.name == "system-album-9") {
            //                 item.iosname = t("famikeep210.Time-Lapse Photography")
            //             } else if (item.name == "system-album-10") {
            //                 item.iosname = t("famikeep210.Slow Motion")
            //             } else if (item.name == "system-album-11") {
            //                 item.iosname = t("famikeep210.Portrait")
            //             } else if (item.name == "system-album-12") {
            //                 item.iosname = t("famikeep210.Burst Mode")
            //             } else if (item.name == "system-album-13") {
            //                 item.iosname = t("famikeep210.Screenshot")
            //             } else if (item.name == "system-album-14") {
            //                 item.iosname = t("famikeep210.Motion")
            //             } else if (item.name == "system-album-15") {
            //                 item.iosname = t("famikeep210.Hide")
            //             }
            //         })
            //     }
            // }
            console.log("是否第一次进入：", isFirst.value);
            let updateTime1 = ((new Date().getTime() - gaStartime))
            console.log("updateTime1:", updateTime1);
            gaEvent("Video_Show", {
                event_category: "Video",
                event_label: updateTime1 + 'ms',
            });
            if (isFirst.value) return
            gaEvent("Video_PV", {
                event_category: "Video",
                event_label: onePageList && onePageList.length > 0 ? 'Data' : 'NoData',
            });
            isFirst.value = true


            // console.log("previewImgList:", previewImgList.value);
        })
        .catch((err: any) => {
            console.log("err:::", err);
            if (isSync) {
                gaEvent("Video_Sync", {
                    event_category: "Video",
                    event_label: 'Fail',
                });
                ElMessage({
                    message: t("chat.syncFailed"),
                    type: "error",
                });
            }
        })
        .finally(() => {
            store.commit("setSyncLoading", false);
            videoLoading.value = false
        })
}
//接收到的时间
const updateHeaderDate = (value: any) => {
    startTime.value = value[0]
    endTime.value = value[1]
    console.log("444444444444444");
    console.log("selectedTagName.value:", selectedTagName.value);
    // albumName
    if (selectedTagName.value == 2 && albumVideo.value) {
        getVideoList(albumName.value)
    } else {
        getVideoList()
    }
    console.log('接收到的时间：', startTime.value, endTime.value);
};
//切换头部选项卡
const clickChangeTags = (val: number) => {
    if (albumVideo.value) return
    if (val == 1) {
        selectedTagName.value = 1
        // if (deviceType.value) {
        //     showRightBox.value = false
        // } else {
        showRightBox.value = true
        // }

    } else {
        selectedTagName.value = 2
        showRightBox.value = false
    }
    currentPage.value = 1
    albumVideo.value = false
    console.log("55555555555555555555");
    if (selectedTagName.value == 2 || isExpired) {
        console.log("999999999999");

        getVideoList()
    }
    // getVideoList()
    console.log(selectedTagName.value);
}
// 根据oos_key获取对应的文件下载地址
const getFileLinkByKey = async (oss_key: any) => {
    const data = {
        oss_key: oss_key,
    };
    try {
        const res = await getFileLinkApi(data);
        // console.log(res, 'getFileLinkByKey');
        if (res.data.code == 200) {
            const fileURL = res.data.data.url;
            return new Promise((resolve, reject) => {
                resolve(fileURL);
            });
        }
    } catch (err) {
        console.log(err);
    }
};
//当天时间的全选
const selectDayAll = (list: any) => {
    console.log("list:", list);

    if (list[1]) {
        list[2].map((item: any) => {
            item.isSelect = true
            if (selectedArray.value.includes(item)) return
            selectedArray.value.push(item)
        })
        console.log("selectedArrayA:", selectedArray.value);

    } else {
        list[2].map((item: any) => {
            item.isSelect = false
            let deleteId = selectedArray.value.findIndex((element) => element.id == item.id)
            selectedArray.value.splice(deleteId, 1)
            console.log("aa:", deleteId);
        })
        console.log("selectedArrayAll:", selectedArray.value);

    }

}
//当前页面全选
const selectAllClick = () => {
    if (isAllSelect.value) {
        videoListArray.value.forEach((element: any) => {
            element[1] = false
            element[2].forEach((item: any) => {
                item.isSelect = false
            });
        });
        selectedArray.value = [];

    } else {
        selectedArray.value = [];

        // Assuming you have an array of all items
        videoListArray.value.forEach((element: any) => {
            element[1] = true
            element[2].forEach((item: any) => {
                item.isSelect = true
                selectedArray.value.push(item)
            });
        });
        console.log("selectedArray:", selectedArray.value);

    }
}
//选中当前相片
const changeCheckBoxStaus = (item: any, videoList: any) => {
    console.log("eeee:", item);
    if (item.isSelect) {
        selectedArray.value.push(item)
    } else {
        console.log("item.id:", item.id);
        selectedArray.value = selectedArray.value.filter((obj: any) => {
            return item.id != obj.id
        })
        console.log("selectedArray.value:", selectedArray.value);

    }
    console.log("selectedArray:", selectedArray.value);

    let dayVideoList = videoList[2].filter((item: any) => item.isSelect)
    if (dayVideoList.length == videoList[2].length) {
        videoList[1] = true
    } else {
        videoList[1] = false
    }
    console.log("select.length:", selectedArray.value.length);
    console.log("dayVideoList.length:", dayVideoList.length, videoList[2].length);
}
//分页
const handleSizeChange = (e: any) => {
    console.log("handleSizeChange:", e);
    currentPage.value = e
    console.log("666666666666666");

    getVideoList()
}
const handleCurrentChange = (e: any) => {
    console.log("handleCurrentChange:", e);
    currentPage.value = e
    console.log("777777777777777777777");
    if (selectedTagName.value == 2 && albumVideo.value) {
        getVideoList(albumName.value)
    } else {
        getVideoList()
    }
}
//文件夹图片
const goalbumVideo = (item: any) => {
    albumVideo.value = true
    albumCurrName.value = item.iosname ? item.iosname : item.name
    showRightBox.value = true
    console.log("8888888888888888888888");
    albumName.value = item.name
    currentPage.value = 1
    if (isVibe.value) {
        getVideoList(item.name)
    }
}
//返回文件夹
const goBackAlbum = () => {
    albumVideo.value = false
    showRightBox.value = false
}
// 修改预览的index
const openPreview = async (item: string) => {
    console.log("item:", item);
    // exitFfmpeg();
    currentVideo.value = item
    isShowVideoPreview.value = true
    iscanPlay.value = await isLoadedSuccess(item.videoUrl ? item.videoUrl : item.url);
    if (!iscanPlay.value) {
        videoError(item)
    }
};
const closePreview = () => {
    isShowVideoPreview.value = false
    showTransFail.value = false
    showTrans.value = false
    exitFfmpeg()
    currentProgress.value = 0
}
//下载文件
const downloadItem = async (item: any) => {
    // if (isVibe.value) {
    //     ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    //     return
    // }
    if (!window.navigator.onLine) {
        ElMessage({
            message: t("networkAbnormaled"),
            type: "error",
        });
    } else {
        console.log("下载开始了");
        gaEvent("Video_Download", {
            event_category: "Video",
            event_label: 1,
        });
        try {
            // await downloadFile(item.url, 'parentalGuard-' + item.name, (downLoadProgress: any) => { });
            await downloadVideo(item.dl_url, item.name ? 'parentalGuard-' + item.name : 'parentalGuard-video', (downLoadProgress: any) => { });
        } catch (err) {
            console.log(err);
        }
        downloadLoading.value = false

    }

};
const boldArr = ref([])
//下载多文件
let downinterval: any;
let requestCount = ref(0)
const downloadZip = async () => {
    // if (isVibe.value) {
    //     ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    //     return
    // }
    const zip = new JSZip()
    boldArr.value = []
    downloadLoading.value = true
    console.log("selectedArray.value:", selectedArray.value);
    if (!window.navigator.onLine) {
        ElMessage({
            message: t("networkAbnormaled"),
            type: "error",
        });
    } else {
        if (selectedArray.value.length == 1) {
            downloadItem(selectedArray.value[0])
            return
        }
        const totalRequests = selectedArray.value.length - 1;
        downinterval = setInterval(async () => {
            if (!selectedArray.value[requestCount.value]) {
                clearInterval(downinterval)
                downinterval = null
                return
            }
            let res
            try {
                requestCount.value++
                res = await downloadVideo(selectedArray.value[requestCount.value - 1].dl_url, 'parentalGuard-' + selectedArray.value[requestCount.value - 1].name, (downLoadProgress: any) => { });
                console.log('获取了res:', res);
            } catch (e) {
                console.log('获取不到res:', e);
            } finally {
                if (requestCount.value > totalRequests) {
                    console.log("该结束了老弟");
                    downloadLoading.value = false
                    clearInterval(downinterval);
                }
            }
        }, 5000)
        gaEvent("Video_Download", {
            event_category: "Video",
            event_label: selectedArray.value.length,
        });
        console.log("下载完了？")
    }

}
//删除视频
const deleteVideoFun = () => {
    let temArray = selectedArray.value.map((item) => item.id)
    gaEvent("Video_Delete", {
        event_category: "Video",
        event_label: temArray.length,
    });
    console.log("temArray:", temArray);
    let params = {
        device_id: deviceId.value,
        ids: temArray
    }
    deletePhoto(params)
        .then(async (res) => {
            console.log("res:::", res);
            isShowDia.value = false
            getVideoList()
        })
        .catch((err) => {
            console.log("err:::", err);
        })

}
// 五分钟定时更新
let closeFiveM: any
closeFiveM = setInterval(() => {
    currentPage.value = 1
    console.log("33333333333333");
    albumName.value = ''
    selectedTagName.value = 1
    albumVideo.value = false
    console.log("9999999999999999999");
    getVideoList()
}, 1000 * 60 * 60 * 12);
// if (deviceType.value) {
//     clearInterval(closeFiveM);
// }
watch(deviceId, async () => {
    currentPage.value = 1
    console.log("33333333333333");
    albumName.value = ''
    selectedTagName.value = 1
    albumVideo.value = false
    await getVideoList()


    setTimeout(() => {
        console.log("previewImgList:", previewImgList.value.length);
        gaEvent("Video_PV", {
            event_category: "Video",
            event_label: previewImgList.value.length > 0 ? 'Data' : 'NoData',
        });
    }, 500);
    if (!isVibe.value || !deviceType.value) {
        clearInterval(closeFiveM);
        setNewInterval()
    }
})
// 设置新的定时器
const setNewInterval = () => {
    closeFiveM = setInterval(() => {
        currentPage.value = 1
        console.log("33333333333333");
        albumName.value = ''
        selectedTagName.value = 1
        albumVideo.value = false
        console.log("2222222222222");

        getVideoList()
    }, 1000 * 60 * 60 * 12);
}
const updateInfo = async () => {
    if (isVibe.value) {
        store.commit("setSyncLoading", false);
        ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
        return
    }

    // if (deviceType.value) {
    //     let params = {
    //         apple_id: appId.value
    //     }
    //     try {
    //         let res = await syncIOSPhotosApi(params);
    //         console.log("res:", res);
    //         if (res.data.sync_status == 'syncing') {
    //             ElMessage({
    //                 message: t("chat.syncSuccessed"),
    //                 type: "success",
    //             });
    //             return
    //         } else if (res.status != 200) {
    //             store.commit("setSyncLoading", false);
    //             ElMessage({
    //                 message: t("chat.syncFailed"),
    //                 type: "error",
    //             });
    //             return
    //         }
    currentPage.value = 1
    getVideoList('', true)
    //     } catch (err: any) {

    //     }
    // }
}
const videoError = async (e: any) => {
    console.log("播放失败了");
    showTrans.value = true
    let isTranscodeSuccess = await videoTranscodeHandler(e.url);
    if (isTranscodeSuccess.result) {
        currentVideo.value.videoUrl = isTranscodeSuccess.videoUrl

        console.log("转码成功111:", isTranscodeSuccess);
        console.log("转码成功111:", currentVideo.value);
        showTrans.value = false
        showTransFail.value = false
        currentProgress.value = 0
    } else {
        console.log("转码失败111");
        showTrans.value = false
        showTransFail.value = true
        currentProgress.value = 0

    }
}
// const uploadFileChange = async (e: any) => {
//     console.log("eeeeeeeeeeee:", e);

//     let isTranscodeSuccess = await videoTranscodeHandler(e);
//     if (isTranscodeSuccess.result) {
//         console.log("转码成功");
//     } else {
//         console.log("转码失败");

//     }

// }
const isLoadedSuccess = (blobUrl: string) => {
    return new Promise<boolean>((resolve, reject) => {
        const videoCont = document.createElement('video');
        videoCont.setAttribute('src', blobUrl);
        videoCont.load();
        // 非视频文件加载报错
        videoCont.addEventListener('error', (e) => {
            resolve(false);
        });
        videoCont.addEventListener('loadedmetadata', (e) => {
            console.log("videoCont:", videoCont);

            // 时长异常的情况抛文件错误
            if (videoCont.duration == Infinity) {
                reject();
            } else if (videoCont.videoWidth && videoCont.videoHeight) {
                // 能正常渲染出宽高，才是正常视频
                resolve(true);
            } else {
                resolve(false);
            }
        });
    });
};
emitter.on("curProgressFun", (e: any) => {
    console.log("eeee:", e);
    currentProgress.value = e
});
const videoCount = ref(0)
onMounted(() => {
    if (isVibe.value) {
        currentPage.value = 1
        getVideoList()


        // getVideoList()
    }
    if (deviceType.value && selectedTagName.value == 1) showRightBox.value = false
    let sectionBox = document.querySelector('.videoBox') as any
    console.log("sectionBox:", sectionBox);
    let videoBoxWidth = sectionBox.offsetWidth //videobox的宽度-40的padding-6的滚动条+17最后一个方块的margin（因为要去掉最后一个的margin所以要加上）
    videoCount.value = Math.floor((videoBoxWidth - 40 - 6 + 17) / 309) //（309 == 292+17）
    console.log("allWidth:", videoBoxWidth - 40 - 6 + 17, videoCount);

})
onUnmounted(() => {
    clearInterval(closeFiveM);
    clearInterval(downinterval);
})

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(publicHeader, {
      headerName: _ctx.$t('famikeep220.Video'),
      headerSyncDate: _unref(lastUpdateTime),
      headerSelectData: [],
      onUpdateHeaderDate: updateHeaderDate,
      onUpdateInfo: updateInfo,
      showUpdateTime: showUpdateTime.value,
      showRightBox: showRightBox.value
    }, {
      headerInfo: _withCtx(() => [
        (!deviceType.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("famikeep220.Please note that videos")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["headerName", "headerSyncDate", "showUpdateTime", "showRightBox"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["left-select checkboxDiv", selectedTagName.value == 1 || (selectedTagName.value == 2 && albumVideo.value) ? '' : 'opacityDiv'])
        }, [
          _createVNode(_component_el_checkbox, {
            class: "checkBox",
            modelValue: isAllSelect.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAllSelect).value = $event)),
            onChange: selectAllClick
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("famikeep220.Select All Videos")), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["rightButtom", selectedArray.value.length > 0 ? '' : 'opacityDiv'])
        }, [
          _withDirectives(_createElementVNode("div", {
            class: "buttomItem pointer",
            style: {"margin-right":"16px"},
            onClick: downloadZip
          }, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Download')), 1)
          ], 512), [
            [_vShow, !downloadLoading.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_7, _hoisted_9, 512), [
            [_vShow, downloadLoading.value]
          ]),
          (!deviceType.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["buttomItem pointer", isVibe.value ? 'demoStyle' : '']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowDia.value = true))
              }, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Delete')), 1)
              ], 2))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (videoLoading.value)
          ? (_openBlock(), _createBlock(loading, {
              key: 0,
              class: "loading"
            }))
          : ((videoListArray.value.length > 0 && selectedTagName.value == 1) || (albumList.value.length > 0 && selectedTagName.value == 2 && !albumVideo.value) || (videoListArray.value.length > 0 && selectedTagName.value == 2 && albumVideo.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("section", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoListArray.value, (videoDays, index) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_el_checkbox, {
                            class: "checkBox",
                            modelValue: videoDays[1],
                            "onUpdate:modelValue": ($event: any) => ((videoDays[1]) = $event),
                            onChange: ($event: any) => (selectDayAll(videoDays))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                          _createElementVNode("span", null, _toDisplayString(videoDays[0]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoDays[2], (item, index1) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "videoItem pointer",
                              id: `video_${index}_${index1}`
                            }, [
                              _createElementVNode("video", {
                                class: "itemPhoto",
                                src: item.videoUrl ? item.videoUrl : item.url,
                                onClick: ($event: any) => (openPreview(item)),
                                fit: "contain"
                              }, null, 8, _hoisted_19),
                              _createElementVNode("img", {
                                src: _imports_3,
                                alt: "",
                                class: "videoPlay",
                                onClick: ($event: any) => (openPreview(item))
                              }, null, 8, _hoisted_20),
                              _createElementVNode("div", {
                                class: "hover-area",
                                style: _normalizeStyle({ 'opacity': item.isSelect ? '1' : '' })
                              }, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_el_checkbox, {
                                    class: "checkBox",
                                    modelValue: item.isSelect,
                                    "onUpdate:modelValue": ($event: any) => ((item.isSelect) = $event),
                                    onChange: ($event: any) => (changeCheckBoxStaus(item, videoListArray.value[index]))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                                  _createElementVNode("span", null, _toDisplayString(item.dateYMD), 1)
                                ]),
                                _createElementVNode("img", {
                                  src: _imports_4,
                                  alt: "",
                                  class: "pointer",
                                  onClick: ($event: any) => (downloadItem(item))
                                }, null, 8, _hoisted_22)
                              ], 4)
                            ], 8, _hoisted_18))
                          }), 256))
                        ])
                      ]))
                    }), 256))
                  ], 512), [
                    [_vShow, selectedTagName.value == 1 || (selectedTagName.value == 2 && albumVideo.value)]
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
              ])),
        _withDirectives(_createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("div", {
            class: "backArrow pointer",
            onClick: goBackAlbum
          }, [
            _hoisted_27,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("famikeep200.Back")), 1)
          ], 512), [
            [_vShow, selectedTagName.value == 2 && albumVideo.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_28, [
            _createVNode(_component_el_pagination, {
              background: "",
              layout: "prev, pager, next",
              total: totalNum.value,
              onSizeChange: handleSizeChange,
              "page-size": 20,
              onCurrentChange: handleCurrentChange,
              "current-page": currentPage.value
            }, null, 8, ["total", "current-page"])
          ], 512), [
            [_vShow, ((selectedTagName.value == 1 && totalNum.value > 0) || (selectedTagName.value == 2 && albumVideo.value && totalNum.value > 0))]
          ])
        ], 512), [
          [_vShow, ((selectedTagName.value == 1 && totalNum.value > 0) || (selectedTagName.value == 2 && albumVideo.value))]
        ])
      ])
    ]),
    (isShowDia.value)
      ? (_openBlock(), _createBlock(changeCancel, {
          key: 0,
          visible: isShowDia.value,
          showTitle: false,
          showclose: false,
          width: 480,
          info: _ctx.$t('famikeep200.confirm to delete'),
          onConfirm: _cache[2] || (_cache[2] = ($event: any) => (isShowDia.value = false)),
          onCancle: deleteVideoFun,
          Cancel: _ctx.$t('pop.yes'),
          Okay: _ctx.$t('famikeep200.Back')
        }, null, 8, ["visible", "info", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (isShowVideoPreview.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("video", {
            src: currentVideo.value.videoUrl ? currentVideo.value.videoUrl : currentVideo.value.url,
            controls: isShowVideoPreview.value,
            controlslist: "nodownload",
            class: "videoShow absoluteCenter"
          }, null, 8, _hoisted_30),
          _createElementVNode("img", {
            src: _imports_7,
            onClick: closePreview,
            class: "videoClose pointer"
          }),
          _withDirectives(_createElementVNode("span", _hoisted_31, [
            _createTextVNode(_toDisplayString(_ctx.$t('famikeep220.Loading')) + "... ", 1),
            _withDirectives(_createElementVNode("span", null, _toDisplayString(currentProgress.value) + "%", 513), [
              [_vShow, currentProgress.value]
            ])
          ], 512), [
            [_vShow, showTrans.value]
          ]),
          _withDirectives(_createElementVNode("span", { class: "videotrans absoluteCenter" }, _toDisplayString(_ctx.$t('famikeep220.Loading failed')), 513), [
            [_vShow, showTransFail.value]
          ]),
          _withDirectives(_createElementVNode("div", { class: "videotrans downloadFail" }, _toDisplayString(_ctx.$t('famikeep220.If the video cannot be loaded')), 513), [
            [_vShow, showTrans.value]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})